module.exports = __webpack_public_path__ + "img/011.845a9133.png";